import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('w-read-only-text-field',_vm._b({scopedSlots:_vm._u([{key:"valueLabel",fn:function(){return [(_vm.hasItems)?_c(VBreadcrumbs,{staticClass:"w-breadcrumbs",attrs:{"items":_vm.internalBreadcrumbs}}):_vm._e()]},proxy:true}],null,false,3446358434)},'w-read-only-text-field',_vm.$props,false)):_c(VBreadcrumbs,{staticClass:"w-breadcrumbs pa-0",attrs:{"items":_vm.internalBreadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }